import Raven from "raven-js";

const ravenMiddleware = () => next => action => {
  try {
    return next(action);
  } catch (err) {
    console.error('[Processing exception to Sentry]', err);
    Raven.captureException(err, {
      extra: {
        action
      }
    });
    throw err;
  }
};

export default ravenMiddleware;